/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Progress_Extra_Achievements_MetaInputs */

const en_us2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.total}`)
};

const pt_br2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de ${i?.total}`)
};

const es_419_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de ${i?.total}`)
};

const pt_pt2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de ${i?.total}`)
};

const fr_fr2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sur ${i?.total}`)
};

const de_de2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.total}`)
};

const it_it2_progress_extra_achievements_meta = /** @type {(inputs: Progress_Extra_Achievements_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{count} of {total}" |
*
* @param {Progress_Extra_Achievements_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_achievements_meta = /** @type {((inputs: Progress_Extra_Achievements_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Achievements_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_achievements_meta(inputs)
	if (locale === "es-419") return es_419_progress_extra_achievements_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_achievements_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_achievements_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_achievements_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_achievements_meta(inputs)
	return en_us2_progress_extra_achievements_meta(inputs)
});
export { progress_extra_achievements_meta as "progress-extra.achievements_meta" }